<template>
    <div id="fundo-imagem">
        <button class="x" @click="$emit('fechar')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x preview-icon"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
        </button>

        <img :src="imagemAberta" id="imagem-aberta">
    </div>
</template>

<script>
export default{
    name: 'ImagemAbertaLandingPage',

    props:{
        imagemAberta: String
    }
}
</script>

<style scoped>
#fundo-imagem{
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    max-width: 90vw;
    max-height: 90vh;
    animation: aparecer 0.4s ease-in;
}

#imagem-aberta{
    display: block;
    max-width: 90vw;
    max-height: 90vh;
    width: auto;
    height: auto;
    object-fit: contain;
    border-radius: 5px;
}

.x{
    position: absolute;
    top: 10px;
    right: 10px;
}
</style>